import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { AuthLayout } from "@/features/auth/components/AuthLayout";
import { StatusBanner } from "@/components/StatusBanner";
import { resendConfirmation } from "@/features/auth/authApi";
import { friendlyAuthError } from "@/lib/errors";
import { ROUTES } from "@/constants/routes";

export function CheckEmail({ email, onReset }) {
  const [status, setStatus] = useState({ state: "idle", message: null });

  const resend = async () => {
    setStatus({ state: "sending", message: null });
    const { error } = await resendConfirmation(email).catch((err) => ({ error: err }));
    setStatus(error ? { state: "error", message: friendlyAuthError(error) } : { state: "sent", message: "A new confirmation link is on its way." });
  };

  return (
    <AuthLayout eyebrow="One more step" title="Check your email.">
      <div data-testid="check-email-screen" className="space-y-6">
        <div className="flex h-11 w-11 items-center justify-center rounded-md border border-border bg-card">
          <MailCheck className="h-5 w-5 text-gold" aria-hidden="true" />
        </div>
        <p className="text-sm leading-relaxed text-foreground/85 sm:text-base">
          If an account can be created for{" "}
          <span data-testid="check-email-address" className="font-semibold text-foreground">{email}</span>, we've sent a
          confirmation link. Open it on this device to activate your MetWorth.
        </p>
        {status.message && (
          <StatusBanner variant={status.state === "error" ? "error" : "success"} testId="resend-status-banner">{status.message}</StatusBanner>
        )}
        <div className="flex flex-wrap gap-3">
          <button type="button" onClick={resend} disabled={status.state === "sending"} data-testid="resend-confirmation-button" className="mw-btn mw-btn-ghost">
            {status.state === "sending" ? "Sending" : "Resend link"}
          </button>
          <button type="button" onClick={onReset} data-testid="use-different-email-button" className="mw-btn mw-btn-ghost">
            Use a different email
          </button>
        </div>
        <Link to={ROUTES.login} data-testid="check-email-login-link" className="mw-link inline-block text-sm">
          Back to sign in
        </Link>
      </div>
    </AuthLayout>
  );
}
